import { Box, Typography } from '@mui/material';
import { ReactComponent as UploadIcon } from '../../../../assets/icons/upload_ocr.svg';
import {ImageContainer} from "./ImageViewer.styled";
import {useTranslation} from "react-i18next";

interface ImageViewerProps {
    previewUrl: string | null;
    fileName: string;
}

const ImageViewer = ({
    previewUrl,
    fileName,
}: ImageViewerProps) => {
    const { t } = useTranslation();

    // view before processing
    if (!previewUrl) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" gap={2} p={4}>
                <UploadIcon style={{ width: '48px', height: '48px' }} aria-hidden="true" />
                <Typography variant="body2" color="textSecondary">
                    {fileName}
                </Typography>
            </Box>
        );
    }

    // view after processing
    return (
        <ImageContainer>
            <img src={previewUrl}
                alt={t('ocr.aria.previewImage') as string}
                style={{ maxWidth: '100%', borderRadius: 12, display: 'block' }}
            />
        </ImageContainer>
    );
};

export default ImageViewer;